import React from "react";

import Show from "./show";

import { connect } from "react-redux";
import { statJobsPeriod, isLoading, getError, getData, reset } from "../../../../../redux/actions/report/jobsPeriod";

import Loader from "../../../../../components/loader";

/**
 * Container:
 *
 *   Se encarga de la conexion entre Redux y el Componente  que presenta los datos
 *
 * De paso en algunos caso, excepto formularios se maneja el Loading y el título.
 *
 * OBS: En formularios es mejor que el 'loading' lo maneje el formulario dado que Formik
 *    si se redibuja pierde los datos, entonces hay que tener cuidado con eso.
 */
class Container extends React.Component {
    /**
     * Parametros
     *  - id:  Se asume que el ID viene por la URL
     */
    constructor(props) {
        super(props);
        this.state = { id: props.match.params.id };
    }

    componentDidMount() {
        this.props.statJobsPeriod(this.state.id);
    }

    componentWillUnmount() {
        this.props.reset();
    }

    render() {
        const { loading, data } = this.props;
        return (
            <>
                <Loader loading={this.props.loading} />
                {!loading && data && data.timestamp && <Show data={this.props.data} {...this.props} />}
            </>
        );
    }
}

function MapStateToProps(state) {
    return {
        error: getError(state),
        loading: isLoading(state),
        data: getData(state),
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        statJobsPeriod: (id) => dispatch(statJobsPeriod(id)),
        reset: () => dispatch(reset()),
    };
};

export default connect(MapStateToProps, mapDispatchToProps)(Container);
